import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-slate-100 px-5 py-10 sm:py-12" data-id="element-70" data-mp="4uqdmw6js2tb">
      <div className="mx-auto flex max-w-[1000px] flex-col items-center gap-5 text-center sm:flex-row sm:gap-8 sm:text-left" data-id="element-71" data-mp="4x32zuemxfge">
        <div className="flex h-28 w-28 shrink-0 flex-col items-center justify-center rounded-full border-[5px] border-orange-500 bg-slate-950 text-white" data-id="element-72" data-mp="etz43f27ezax">
          <ShieldCheckIcon className="h-8 w-8 text-orange-500" aria-hidden="true" data-id="element-73" data-mp="jsafvvc27jvs" />
          <span className="mt-1 text-[0.95rem] font-black uppercase leading-none tracking-tight" data-id="element-74" data-mp="nskw00tkfqod">
            7 days
          </span>
        </div>
        <div data-id="element-75" data-mp="xjnvwzardzm2">
          <h2 className="text-balance text-[clamp(1.5rem,4vw,2.4rem)] font-black uppercase leading-none tracking-tight text-slate-950" data-id="element-76" data-mp="xkgwfij4jsvr">
            Your purchase is{' '}
            <span className="text-orange-700" data-id="element-77" data-mp="17i4ou1t9coar">100% protected</span>
          </h2>
          <p className="mt-3 text-[1rem] leading-relaxed text-slate-700 sm:text-[1.1rem]" data-id="element-78" data-mp="17g0o1sqno5ep">
            Explore ANATOMY READY™ for 7 days. Access the complete 6-volume
            visual Anatomy & Physiology teaching system and all 5 premium
            bonuses. If it isn't right for you, contact us within 7 days for a
            full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}